import { LoadingButton } from '../buttons/LoadingButton';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { DialogCentered } from '../DialogCentered';

type NotEnoughFundsProps = {
  open: boolean;
  handleClose: () => void;
  setOpen: (x: boolean) => void;
  handleOnRamper: () => Promise<void>;
  coin: string;
};

export const NotEnoughFunds = ({
  handleClose,
  open,
  setOpen,
  handleOnRamper,
  coin,
}: NotEnoughFundsProps) => {
  const handleClick = async () => {
    setOpen(false);
    await handleOnRamper();
  };
  return (
    <DialogCentered open={open} onClose={handleClose}>
      {`You don't have enough ${coin} to mint this item.`}
      <LoadingButton
        onClick={handleClick}
        variant="contained"
        size="large"
        color="primary"
        startIcon={<AccountBalanceWalletOutlinedIcon />}
        sx={{ mt: 4 }}
      >
        Add funds
      </LoadingButton>
    </DialogCentered>
  );
};
